var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./CommonStoryImage.jinja');
require('./CommonStoryImage.less');

module.exports = Base.extend({

    template: template,


    initialize: function (options) {
        this.options = options || {};

        Base.prototype.initialize.call(this, options);
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/CommonStory/CommonStoryImage.js
// module id = 95
// module chunks = 0